import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import * as c from '../constant';
import * as actions from '../action';

const BusinessAuditLogs = ({
  data,
  getBusinessAuditLogs,
  businessAuditLogs,
}) => {
  const setModal = useContext(ModalContext);
  const id = _.get(data, 'id');

  useEffect(() => {
    getBusinessAuditLogs(id);
  }, []);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              <table className="table table-bordered table-sm table-hover">
                <thead className="table-header">
                  <tr>
                    <td>User Type</td>
                    <td>Name</td>
                    <td>Actions</td>
                    <td>Date</td>
                  </tr>
                </thead>
                <tbody className="table-details">
                  {businessAuditLogs.map(item => {
                    return (
                      <tr key={`business_logs${item.id}`}>
                        <td>{_.get(item, 'attributes.user_type') || '---'}</td>
                        <td>{_.get(item, 'attributes.user_name') || '---'}</td>
                        <td>{_.get(item, 'attributes.event') || '---'}</td>
                        <td>{_.get(item, 'attributes.created_at') || '---'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
};

BusinessAuditLogs.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  getBusinessAuditLogs: PropTypes.instanceOf(Function).isRequired,
  businessAuditLogs: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessAuditLogs: _.get(api, `${c.GET_BUSINESS_AUDIT_LOGS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BusinessAuditLogs);
